<rx-modal-content [showCloseButton]="showCloseButton" [headerCentered]="headerCentered" (closeModal)="activeModal.dismiss()">
  <h4 *ngIf="title" class="modal-title">
    {{ title }}
  </h4>
  <div
    *ngIf="body"
    class="modal-body d-flex flex-column"
    [ngClass]="{ 'align-items-center': bodyCentered, 'align-items-start': !bodyCentered }"
  >
    <p>{{ body }}</p>
  </div>
  <div
    class="modal-footer"
    [ngClass]="{ 'border-top-0': !body, 'justify-content-center': buttonsCentered, 'justify-content-end': !buttonsCentered }"
  >
    <rx-button buttonClass="secondary" (click)="activeModal.dismiss()" data-qa="cancel">
      {{ cancelLabel }}
    </rx-button>
    <rx-button buttonClass="primary" ngbAutofocus (click)="activeModal.close()" data-qa="confirm">
      {{ confirmLabel }}
    </rx-button>
  </div>
</rx-modal-content>
